import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GlobalLoadingService } from '../../services/global-loading.service';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-global-loading',
  imports: [MatProgressSpinnerModule, NgIf, MatIcon],
  templateUrl: './global-loading.component.html',
  styleUrl: './global-loading.component.scss'
})
export class GlobalLoadingComponent {

  private globalService = inject(GlobalLoadingService)

  loading = this.globalService.loading;
}
